/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q4_QuestionInputs */

const en_home_faq_q4_question = /** @type {(inputs: Home_Faq_Q4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I submit a claim through the portal?`)
};

const fr_home_faq_q4_question = /** @type {(inputs: Home_Faq_Q4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je soumettre une réclamation via le portail ?`)
};

/**
* | output |
* | --- |
* | "Can I submit a claim through the portal?" |
*
* @param {Home_Faq_Q4_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q4_question = /** @type {((inputs?: Home_Faq_Q4_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q4_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q4_question(inputs)
	return fr_home_faq_q4_question(inputs)
});